import {getOrderTotalWithTax} from "../../utils/pricing";
import {useCartAmounts} from "../../hooks/useCartAmounts";
import { useSelector } from "react-redux";
import { OrderInfo } from "./order";
import { useMemo, useState, useCallback } from "react";

const toNumber = (v) => {
  if (typeof v === "number") return Number.isFinite(v) ? v : 0;
  if (v == null) return 0;
  const n = Number(String(v).replace(",", "."));
  return Number.isFinite(n) ? n : 0;
};

export const OrderMobile = () => {
  const cart = useSelector((state) => state.aplicationConfig.userConfig.cart);
  const order = useSelector((state) => state.aplicationConfig.userConfig.order);
  const [orderVisible, setOrderVisible] = useState(false);

  const quote = useCartAmounts();
  const total = order?.orderId ? getOrderTotalWithTax(order) : (quote.amounts || quote.displayAmounts)?.total;
  const itemsCount = useMemo(() => {
    const list = order?.orderId ? order.products || [] : cart?.ShoppingCartProducts || [];
    return list.reduce((acc, item) => acc + (toNumber(item?.quantity) || 0), 0);
  }, [cart?.ShoppingCartProducts, order]);

  const toggleOrderVisible = useCallback(() => {
    setOrderVisible((prev) => !prev);
  }, []);

  return (
    <>
      {orderVisible && (
        <div id="order-mobile-panel" className="orderMobile">
          <div className="order-commander-body-content">
            <OrderInfo onOrderConfirmed={() => setOrderVisible(false)} />
          </div>
        </div>
      )}

      <div className="bottom-toolbar">
        <div aria-busy={!order?.orderId && quote.busy} title={quote.busy ? "Actualizando importe; último cálculo confirmado" : undefined} style={{ fontWeight: "bold", width: "33%" }}>
          € {Number.isFinite(total) ? total.toFixed(2) : "—"}
        </div>

        <div
          style={{
            backgroundColor: "var(--color-primary-shadow)",
            padding: "5px 25px",
            borderRadius: "10px",
          }}
          aria-label={`Productos en ${order?.orderId ? "pedido" : "carrito"}: ${itemsCount}`}
        >
          {itemsCount}
        </div>

        <button
          type="button"
          onClick={toggleOrderVisible}
          style={{
            border: "0",
            backgroundColor: "transparent",
            color: "var(--color-process)",
            width: "33%",
          }}
          aria-expanded={orderVisible}
          aria-controls="order-mobile-panel"
        >
          Comanda
        </button>
      </div>
    </>
  );
};
